export enum ReducersEnum {
  MAIN = "main",
}

export interface IMainReducerState {
  // change it based on requirement
  data: any
}